// extracted by mini-css-extract-plugin
export var deliveryRow = "_ku-a";
export var fixedHeight = "_ku-4";
export var freightLogo = "_ku-9";
export var fullWidth = "_ku-3";
export var priceColumn = "_ku-5";
export var radioSelected = "_ku-7";
export var radioUnselected = "_ku-6";
export var selectedOption = "_ku-2";
export var selectedOptionContainer = "_ku-1";
export var selection = "_ku-0";
export var tallSkeletonText = "_ku-8";